import React, { Fragment } from "react";
import { Card, CardBody, Col, Container, Row, Label, Input, Table } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import CardLoader from "../components/CardLoader";
import MySearchOption from "../components/MySearchOption";
import IsoDashboardList from '../components/IsoDashboardList';

import { useDispatch, useSelector } from "react-redux";
import * as isoDashboardActions from "../actions/IsoDashboardActions";

const IsoDashboardScreen  = (props) => {
    const dispatch = useDispatch();

    const loading = useSelector((state) => state.isodashboard.loading);
    const search = useSelector((state) => state.isodashboard.search);
    const mineOnly = useSelector((state) => state.isodashboard.mineOnly);

    const draftList = useSelector((state) => state.isodashboard.draftList);
    const salesActionList = useSelector((state) => state.isodashboard.salesActionList);
    const newList = useSelector((state) => state.isodashboard.newList);
    const schedulingList = useSelector((state) => state.isodashboard.schedulingList);
    const calculateManDaysList = useSelector((state) => state.isodashboard.calculateManDaysList);
    const auditInProgressList = useSelector((state) => state.isodashboard.auditInProgressList);
    const documentReviewList = useSelector((state) => state.isodashboard.documentReviewList);
    const technicalReviewList = useSelector((state) => state.isodashboard.technicalReviewList);
    const decisionMakingList = useSelector((state) => state.isodashboard.decisionMakingList);
    const completedList = useSelector((state) => state.isodashboard.completedList);
    const closedList = useSelector((state) => state.isodashboard.closedList);
    const abortedList = useSelector((state) => state.isodashboard.abortedList);

    const searchList = useSelector((state) => state.isodashboard.searchList);
    
    const user = useSelector((state) => state.login.user);

    const [fboSearch, setFBOSearch] = React.useState(search);
    const [fboMineOnly, setFBOMineOnly] = React.useState(mineOnly);

    const [showIsoDraft, setShowIsoDraft] = React.useState(user.showIsoDraft);
    const [showIsoSalesAction, setShowIsoSalesAction] = React.useState(user.showIsoSalesAction);
    const [showIsoNew, setShowIsoNew] = React.useState(user.showIsoNew);
    const [showIsoScheduling, setShowIsoScheduling] = React.useState(user.showIsoScheduling);
    const [showIsoCalculateManDays, setShowIsoCalculateManDays] = React.useState(user.showIsoCalculateManDays);
    const [showIsoAuditInProgress, setShowIsoAuditInProgress] = React.useState(user.showIsoAuditInProgress);
    const [showIsoDocumentReview, setShowIsoDocumentReview] = React.useState(user.showIsoDocumentReview);
    const [showIsoTechnicalReview, setShowIsoTechnicalReview] = React.useState(user.showIsoTechnicalReview);
    const [showIsoDecisionMaking, setShowIsoDecisionMaking] = React.useState(user.showIsoDecisionMaking);
    const [showIsoCompleted, setShowIsoCompleted] = React.useState(user.showIsoCompleted);
    const [showIsoClosed, setShowIsoClosed] = React.useState(user.showIsoClosed);
    const [showIsoAborted, setShowIsoAborted] = React.useState(user.showIsoAborted);
    
    React.useEffect(() => {
		dispatch(isoDashboardActions.loadIsoDashboard("", fboSearch, fboMineOnly));
    }, []);

    React.useEffect(() => {
		setFBOSearch(search);
    }, [search]);

    React.useEffect(() => {
		setFBOMineOnly(mineOnly);
    }, [mineOnly]);

    const searchTickets = () => {
        dispatch(isoDashboardActions.loadIsoDashboard("", fboSearch, fboMineOnly));

        dispatch(isoDashboardActions.setIsoDashboardFilterSearch(fboSearch));
        dispatch(isoDashboardActions.setIsoDashboardFilterMineOnly(fboMineOnly));
    }

    const showMyTicketsOnly = () => {
        if(user && user.showMyIsoTicketsOnly) {
            return true;
        }

        return false;
    }

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h4 className="mb-sm-0">TICKET LIST</h4>
                                    </div>
                                    <div className="flex-shrink-0">
                                        {!showIsoDraft && draftList.length > 0 && <span className="badge bg-dark ms-2">DRAFT: {draftList.length}</span>}
                                        {!showIsoSalesAction && salesActionList.length > 0 && <span className="badge bg-info ms-2">SALES: {salesActionList.length}</span>}
                                        {!showIsoNew && newList.length > 0 && <span className="badge bg-primary ms-2">NEW: {newList.length}</span>}
                                        {!showIsoScheduling && schedulingList.length > 0 && <span className="badge bg-warning ms-2">SCHEDULE: {schedulingList.length}</span>}
                                        {!showIsoCalculateManDays && calculateManDaysList.length > 0 && <span className="badge bg-warning ms-2">CALCULATE: {calculateManDaysList.length}</span>}
                                        {!showIsoAuditInProgress && auditInProgressList.length > 0 && <span className="badge bg-phase-1 ms-2">AUDIT: {auditInProgressList.length}</span>}
                                        {!showIsoDocumentReview && documentReviewList.length > 0 && <span className="badge bg-document-review ms-2">DOC REVW: {documentReviewList.length}</span>}
                                        {!showIsoTechnicalReview && technicalReviewList.length > 0 && <span className="badge bg-phase-2 ms-2">TECH REVW: {technicalReviewList.length}</span>}
                                        {!showIsoDecisionMaking && decisionMakingList.length > 0 && <span className="badge bg-final-decision ms-2">DECISION: {decisionMakingList.length}</span>}
                                        {!showIsoCompleted && completedList.length > 0 && <span className="badge bg-complete ms-2">COMPLETE: {completedList.length}</span>}
                                        {!showIsoClosed && closedList.length > 0 && <span className="badge bg-success ms-2">CLOSE: {closedList.length}</span>}
                                        {!showIsoAborted && abortedList.length > 0 && <span className="badge bg-secondary ms-2">ABORT: {abortedList.length}</span>}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <MySearchOption
                                        placeholder={"Search for ISO Tickets..."}
                                        value={fboSearch}
                                        searchList={searchList || []}
                                        fieldName=""
                                        onChange={setFBOSearch}
                                    />
                                    <div className={`form-check pt-2 ms-2 me-2 ${showMyTicketsOnly() ? "" : "d-none"}`}>
                                        <input type="checkbox" className="form-check-input"
                                            checked={fboMineOnly}
                                            onChange={e => setFBOMineOnly(e.target.checked)}
                                        /> My Tickets Only
                                    </div>
                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Search Tickets"
                                        onClick={() => searchTickets()}
                                    >
                                        <i className="ri-search-line" />
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <div className="tasks-board mb-3" id="kanbanboard">
                            <CardLoader loading={loading} />
                            {showIsoDraft && <IsoDashboardList title="Draft" titleClass="bg-dark" borderClass="border-dark" list={draftList}  />}
                            {showIsoSalesAction && <IsoDashboardList title="Sales Action" titleClass="bg-info" borderClass="border-info" list={salesActionList} />}
                            {showIsoNew && <IsoDashboardList title="New" titleClass="bg-primary" borderClass="border-primary" list={newList} />}
                            {showIsoScheduling && <IsoDashboardList title="Scheduling" titleClass="bg-info" borderClass="border-info" list={schedulingList} />}
                            {showIsoCalculateManDays && <IsoDashboardList title="Calculate Man Days" titleClass="bg-warning" borderClass="border-warning" list={calculateManDaysList} />}
                            {showIsoAuditInProgress && <IsoDashboardList title="Audit In Progress" titleClass="bg-audit" borderClass="border-audit" list={auditInProgressList} />}
                            {showIsoDocumentReview && <IsoDashboardList title="Document Review" titleClass="bg-document-review" borderClass="border-document-review" list={documentReviewList} />}
                            {showIsoTechnicalReview && <IsoDashboardList title="Technical Review" titleClass="bg-phase-2" borderClass="border-phase-2" list={technicalReviewList} />}
                            {showIsoDecisionMaking && <IsoDashboardList title="Decision Making" titleClass="bg-final-decision" borderClass="border-final-decision" list={decisionMakingList} />}
                            {showIsoCompleted && <IsoDashboardList title="Completed" titleClass="bg-complete" borderClass="border-complete" list={completedList} />}
                            {showIsoClosed && <IsoDashboardList title="Closed" titleClass="bg-success" borderClass="border-success" list={closedList} />}
                            {showIsoAborted && <IsoDashboardList title="Aborted" titleClass="bg-secondary" borderClass="border-secondary" list={abortedList} />}
                        </div>
                    </Row>                
                </Container>
            </div>
        </Fragment>
    );
}

export default IsoDashboardScreen;